/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ documentType: NonNullable<unknown> }} Task_Requested_Documents_Existing_Confirm_DescriptionInputs */

const en_task_requested_documents_existing_confirm_description = /** @type {(inputs: Task_Requested_Documents_Existing_Confirm_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A "${i?.documentType}" document has already been added to this case. Continue with the request?`)
};

const pt_br2_task_requested_documents_existing_confirm_description = /** @type {(inputs: Task_Requested_Documents_Existing_Confirm_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Um documento do tipo "${i?.documentType}" já foi adicionado ao caso. Deseja continuar a solicitação?`)
};

/**
* | output |
* | --- |
* | "A \"{documentType}\" document has already been added to this case. Continue with the request?" |
*
* @param {Task_Requested_Documents_Existing_Confirm_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_requested_documents_existing_confirm_description = /** @type {((inputs: Task_Requested_Documents_Existing_Confirm_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Requested_Documents_Existing_Confirm_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_requested_documents_existing_confirm_description(inputs)
	return pt_br2_task_requested_documents_existing_confirm_description(inputs)
});